/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ItemAttributeValue
 */
export interface ItemAttributeValue {
  /**
   *
   * @type {string}
   * @memberof ItemAttributeValue
   */
  value: string
  /**
   *
   * @type {number}
   * @memberof ItemAttributeValue
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof ItemAttributeValue
   */
  updatedAt: number
}

/**
 * Check if a given object implements the ItemAttributeValue interface.
 */
export function instanceOfItemAttributeValue(
  value: object,
): value is ItemAttributeValue {
  if (!('value' in value) || value['value'] === undefined) return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function ItemAttributeValueFromJSON(json: any): ItemAttributeValue {
  return ItemAttributeValueFromJSONTyped(json, false)
}

export function ItemAttributeValueFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ItemAttributeValue {
  if (json == null) {
    return json
  }
  return {
    value: json['value'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
  }
}

export function ItemAttributeValueToJSON(json: any): ItemAttributeValue {
  return ItemAttributeValueToJSONTyped(json, false)
}

export function ItemAttributeValueToJSONTyped(
  value?: ItemAttributeValue | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    value: value['value'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
  }
}
